import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDataWAuth, postDataWAuth, putDataWAuth, deleteDataWAuth } from "../../../utils/api-service";
import {
  IB_GET_MACHINES,
  IB_ADD_MACHINES,
  IB_EDIT_MACHINES,
  IB_DELETE_MACHINES,
} from "../../../constants/constant";

export const fetchMachines = createAsyncThunk(
  "machines/fetchMachines",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDataWAuth(IB_GET_MACHINES);
      const data = response.data || [];
      const dataWithId = data.map((item, index) => ({
        ...item,
        id: item.machineId || index,
      }));
      return dataWithId;
    } catch (error) {
      return rejectWithValue( error);
    }
  }
);

export const createMachine = createAsyncThunk(
  "machines/createMachine",
  async (machineData, { rejectWithValue }) => {
    try {
      const response = await postDataWAuth(IB_ADD_MACHINES, machineData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateMachine = createAsyncThunk(
  "machines/updateMachine",
  async (machineData, { rejectWithValue }) => {
    try {
      const response = await putDataWAuth(IB_EDIT_MACHINES, machineData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteMachine = createAsyncThunk(
  "machines/deleteMachine",
  async (machineId, { rejectWithValue }) => {
    try {
      await deleteDataWAuth(IB_DELETE_MACHINES, { id: machineId });
      return machineId;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  machines: [],
  loading: false,
  actionLoading: false,
  error: null,
};

const machinesSlice = createSlice({
  name: "machines",
  initialState,
  reducers: {
    clearMachinesError: (state) => {
      state.error = null;
    },
    resetMachines: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMachines.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMachines.fulfilled, (state, action) => {
        state.loading = false;
        state.machines = action.payload;
      })
      .addCase(fetchMachines.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(createMachine.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(createMachine.fulfilled, (state, action) => {
        state.actionLoading = false;
      })
      .addCase(createMachine.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(updateMachine.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(updateMachine.fulfilled, (state, action) => {
        state.actionLoading = false;
      })
      .addCase(updateMachine.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(deleteMachine.pending, (state) => {
        state.actionLoading = true;
        state.error = null;
      })
      .addCase(deleteMachine.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.machines = state.machines.filter(machine => machine.id !== action.payload);
      })
      .addCase(deleteMachine.rejected, (state, action) => {
        state.actionLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMachinesError, resetMachines } = machinesSlice.actions;
export default machinesSlice.reducer;
